import React from "react";

/**
 * @name useAlertWhenRefreshed
 * @description to display message when browser refresh button is clicked or tab is being closed
 */

function useAlertWhenRefreshed() {
  const beforeUnloadHandler = React.useCallback((event: Event) => {
    // Cancel the event
    event.preventDefault();
    // Chrome requires returnValue to be set.
    event.returnValue = false;
  }, []);

  React.useEffect(() => {
    window.addEventListener("beforeunload", beforeUnloadHandler);
    return () => {
      window.removeEventListener("beforeunload", beforeUnloadHandler);
    };
  }, [beforeUnloadHandler]);
}

export default useAlertWhenRefreshed;
